export const SERVICE_RULES = [
  {
    key: "general",
    title: "Общие положения",
    summary:
      "Правила регулируют использование платформы InChat для корпоративного обучения сотрудников.",
    data: [
      {
        point: 1,
        text: "Сервис предназначен для создания, публикации и распространения интерактивных сценариев через Telegram-бота.",
      },
      {
        point: 2,
        text: "Регистрация и использование сервиса означает согласие с настоящими Правилами, Публичной офертой и Политикой конфиденциальности.",
      },
      {
        point: 3,
        text: "Администрация вправе изменять Правила с публикацией актуальной версии на сайте. Продолжение использования сервиса после изменений означает согласие с новой редакцией.",
      },
    ],
  },
  {
    key: "account",
    title: "Аккаунт и доступ",
    summary: "Требования к учётной записи администратора и безопасности входа.",
    data: [
      {
        point: 1,
        text: "Один администратор аккаунта вправе иметь один рабочий профиль. Создание дубликатов для обхода ограничений или блокировок запрещено.",
      },
      {
        point: 2,
        text: "Администратор обязан указывать достоверный адрес электронной почты и не передавать учётные данные третьим лицам.",
      },
      {
        point: 3,
        text: "При нарушении Правил аккаунт может быть ограничен или заблокирован, а созданный контент — удалён или скрыт.",
      },
    ],
  },
  {
    key: "content",
    title: "Контент и модерация",
    summary: "Что можно и нельзя размещать в сценариях.",
    data: [
      {
        point: 1,
        text: "Администратор аккаунта несёт полную ответственность за тексты, видео, изображения и сценарии, которые загружает в сервис.",
      },
      {
        point: 2,
        text: "Запрещён контент, нарушающий законодательство РФ: экстремизм, пропаганда насилия, дискриминация, мошенничество, нарушение авторских прав, персональные данные третьих лиц без согласия.",
      },
      {
        point: 3,
        text: "Запрещено размещать в материалах скрытую рекламу, вводящие в заблуждение обещания, а также ссылки на сторонние ресурсы без явного указания их назначения.",
      },
      {
        point: 4,
        text: "Администрация вправе проверять сценарии, запрашивать пояснения у владельца аккаунта и удалять материалы, нарушающие Правила или требования закона.",
      },
    ],
  },
  {
    key: "files",
    title: "Видео и медиафайлы",
    summary: "Технические ограничения и требования к загрузке.",
    data: [
      {
        point: 1,
        text: "Размер одного загружаемого видеофайла не должен превышать 100 МБ, если иное не указано в интерфейсе сервиса.",
      },
      {
        point: 2,
        text: "При доставке видео конечному пользователю в Telegram файл может передаваться частями — это техническая особенность канала доставки.",
      },
      {
        point: 3,
        text: "Администратор гарантирует наличие прав на использование загружаемых видео, изображений и иных материалов.",
      },
      {
        point: 4,
        text: "Сервис может создавать технические превью (скриншоты) из загруженного видео для отображения в редакторе сценария.",
      },
    ],
  },
  {
    key: "access",
    title: "Доступ к сценариям",
    summary: "Групповой доступ по бизнес-подписке.",
    data: [
      {
        point: 1,
        text: "Компании оформляют подписку на групповой доступ по размеру команды (до 15, 16–50, 51–100 сотрудников). Сотрудники проходят сценарий по общей ссылке в Telegram.",
      },
      {
        point: 2,
        text: "При регистрации подписка не начисляется. Редактор доступен для подготовки сценария; для публикации и доступа команды необходимо оформить тариф.",
      },
      {
        point: 3,
        text: "Для компаний от 100 сотрудников условия согласуются индивидуально через support@club-lab.ru.",
      },
    ],
  },
  {
    key: "payment",
    title: "Оплата и цифровые услуги",
    summary: "Порядок приобретения подписки.",
    data: [
      {
        point: 1,
        text: "Оплата услуг осуществляется через платёжного партнёра ЮKassa в рублях РФ.",
      },
      {
        point: 2,
        text: "Моментом оплаты считается подтверждение успешной транзакции платёжной системой.",
      },
      {
        point: 3,
        text: "После подтверждения оплаты подписка на групповой доступ активируется на аккаунте администратора.",
      },
      {
        point: 4,
        text: "Подробные условия оказания платных услуг изложены в Публичной оферте на сайте сервиса.",
      },
    ],
  },
  {
    key: "refund",
    title: "Возврат денежных средств",
    summary: "В соответствии с ЗоЗПП и правилами цифровых товаров.",
    data: [
      {
        point: 1,
        text: "Возврат возможен при технической ошибке оплаты, двойном списании или невозможности предоставить оплаченную услугу по вине сервиса.",
      },
      {
        point: 2,
        text: "Цифровые услуги и ключи доступа, предоставленные надлежащего качества и фактически зачисленные на аккаунт, возврату не подлежат, за исключением случаев, прямо предусмотренных законом.",
      },
      {
        point: 3,
        text: "Запрос на возврат направляется на support@club-lab.ru с указанием email аккаунта, даты и суммы платежа.",
      },
      {
        point: 4,
        text: "Возврат производится тем же способом, которым была произведена оплата, через платёжного партнёра.",
      },
    ],
  },
  {
    key: "personal-data",
    title: "Персональные данные",
    summary: "Обработка данных в соответствии с ФЗ-152.",
    data: [
      {
        point: 1,
        text: "Оператор обрабатывает персональные данные пользователей в целях регистрации, оказания услуг, оплаты, поддержки и исполнения требований законодательства РФ.",
      },
      {
        point: 2,
        text: "Обрабатываемые данные могут включать: email, идентификатор аккаунта, сведения об оплатах, технические логи, а также данные, которые автор добровольно указывает в сценариях.",
      },
      {
        point: 3,
        text: "Правовым основанием обработки являются согласие пользователя, исполнение договора (оферты) и требования закона.",
      },
      {
        point: 4,
        text: "Пользователь вправе запросить уточнение, блокирование или удаление персональных данных, направив обращение на support@club-lab.ru.",
      },
      {
        point: 5,
        text: "Подробный порядок обработки персональных данных изложен в Политике конфиденциальности на сайте сервиса.",
      },
    ],
  },
  {
    key: "ip",
    title: "Интеллектуальная собственность",
    summary: "Права на платформу и пользовательский контент.",
    data: [
      {
        point: 1,
        text: "Программный код, дизайн и элементы интерфейса сервиса принадлежат правообладателю платформы.",
      },
      {
        point: 2,
        text: "Автор сохраняет права на созданные им сценарии и предоставляет сервису неисключительную лицензию на хранение, обработку и демонстрацию контента в рамках работы платформы.",
      },
      {
        point: 3,
        text: "Жалобы на нарушение авторских прав принимаются на support@club-lab.ru с описанием спорного материала и подтверждением прав.",
      },
    ],
  },
  {
    key: "liability",
    title: "Ответственность и ограничения",
    summary: "Распределение рисков между сервисом и автором.",
    data: [
      {
        point: 1,
        text: "Сервис предоставляется «как есть». Администрация не гарантирует бесперебойную работу Telegram, платёжных систем и каналов связи третьих лиц.",
      },
      {
        point: 2,
        text: "Сервис не несёт ответственности за содержание пользовательских сценариев и действия конечных пользователей Telegram-бота.",
      },
      {
        point: 3,
        text: "Автор обязан самостоятельно соблюдать требования законодательства о рекламе, персональных данных, защите детей и интеллектуальной собственности.",
      },
    ],
  },
  {
    key: "support",
    title: "Поддержка и контакты",
    summary: "Как связаться с администрацией сервиса.",
    data: [
      {
        point: 1,
        text: "По вопросам работы сервиса, оплаты, персональных данных и модерации: support@club-lab.ru.",
      },
      {
        point: 2,
        text: "Telegram поддержки: @MoGame_Support.",
      },
      {
        point: 3,
        text: "Срок рассмотрения обращений — до 10 рабочих дней, если иной срок не установлен законом.",
      },
    ],
  },
];

export const RULES_LINKS = [
  {
    label: "Публичная оферта",
    href: "/oferta",
  },
  {
    label: "Политика конфиденциальности",
    href: "/politic-confidencial",
  },
];
